import { connect, MapStateToProps } from 'react-redux';
import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import { Props } from './ShopPremiumFolders';

import { AppState } from '../../../../../types/store';
import { getShopItemsStreamId } from '../../../../streams/shop';
import { ShopItemType } from '../../../../../types/shop';

type StateProps = Pick<Props, 'total'>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const streamId = getShopItemsStreamId(ShopItemType.PREMIUM_FOLDERS);
  const itemIds = streamSelectors.getItems(state, streamId);

  return {
    total: itemIds.length,
  };
};

export default connect(mapStateToProps, null);
